import { Button, ConfigProvider, theme, Tooltip } from 'antd';
import React from 'react';
import propTypes from "prop-types";
import { GET } from '../../frameworks/HttpClient';
import { PrinterOutlined } from '@ant-design/icons';
import ColorButton from '../../common/ColorButton';
import { PRINT_COLOR } from '../../constants/color';


export default function ReportButton ({ 
  children, 
  url,
  tooltip,
  type='primary',
  override=PRINT_COLOR,
  hideIcon=false,
  icon=(<PrinterOutlined/>),
  style={},
  data={},
  sentError=() => null,
  sentLoading=() => null,
  ...buttonProps
}) {
  const { token } = theme.useToken();
  const [loading, setLoading] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState(null);
  
  const handleDocument = async() => {
    sentError(null);
    setLoading(true);
    sentLoading(true);
    try {
      const response = await GET(url, data,  false, true)
      const fileURL = URL.createObjectURL(response.data)
      await window.open(fileURL, '_blank')
    } catch (error) {
      sentError(error.errorMessages);
      setLoading(false);
    } finally {
      setLoading(false);
      sentLoading(false);
    }
  }; 

  return (
    <Tooltip title={tooltip}>
      <ColorButton
        type={type}
        override={override}
        icon={hideIcon === true ? null : icon}
        style={{ margin : hideIcon ? 0 : 5, ...style}}
        onClick={()=> handleDocument()}
        loading={loading}
        {...buttonProps}
      >
        {children}
      </ColorButton>
    </Tooltip>
  )
};
ReportButton.defaultProps = {
  children: () => null,
  url: '',
  tooltip: '',
}

ReportButton.prototype = {
  children: propTypes.func,
  url: propTypes.string,
  tooltip: propTypes.string,
}